import CategoryApi from 'api/category'
import lodash from 'lodash'
// import Vue from 'vue'

const CATEGORIES_INDEX = 'CATEGORIES_INDEX'
const CATEGORIES_CREATE_OR_UPDATE = 'CATEGORIES_CREATE_OR_UPDATE'
const CATEGORIES_DESTROY = 'CATEGORIES_DESTROY'
// const CATEGORIES_LOAD_PROJECTS = 'CATEGORIES_LOAD_PROJECTS'

const state = {
  items: [] // store all categories info
  // all: [] // store all projects in all tag
}

const getters = {}

const mutations = {
  [CATEGORIES_INDEX](state, { categories }) {
    state.items = categories
  },
  [CATEGORIES_CREATE_OR_UPDATE](state, { category }) {
    let id = category.id
    let oldIndex = lodash.findIndex(state.items, { id: id })

    if (oldIndex >= 0) {
      // replace rather than insert
      state.items.splice(oldIndex, 1, category)
    } else {
      state.items.push(category)
    }
  },
  [CATEGORIES_DESTROY](state, id) {
    let oldIndex = lodash.findIndex(state.items, { id: id })
    state.items.splice(oldIndex, 1)
  }
}

const actions = {
  // index: get all categories
  index({ state, rootGetters, commit }) {
    return CategoryApi.index({
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    }).then(res => {
      commit(CATEGORIES_INDEX, { categories: res.data.list })
    })
  },
  // create or update a category, depends on whether there was an 'id' attribute
  // return the id of new/updated category
  create_or_update({ rootGetters, commit }, params) {
    return CategoryApi.createOrUpdate(lodash.merge(params, {
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    })).then(res => {
      commit(CATEGORIES_CREATE_OR_UPDATE, { category: res.data })
      return res.data.id
    })
  },

  // show: get a specific category by its id
  get({ state, commit }, { id, force }) {
    // set current category with its id
    let _id = Number(id)
    if (isNaN(_id)) throw new Error('params error')

    let _cat = state.items.find(value => value.id === _id)

    return (_cat && !force) ? Promise.resolve(_cat) : CategoryApi.show(_id).then(res => {
      commit(CATEGORIES_CREATE_OR_UPDATE, { category: res.data })
    })
  },

  // destroy: delete a category
  destroy({ state, commit }, id) {
    let _id = Number(id)
    if (isNaN(_id)) throw new Error('params error')

    CategoryApi.destroy(_id).then(res => {
      commit(CATEGORIES_DESTROY, _id)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/category.js